

































































































































import Vue from "vue"
import {Office} from "@/model/entity/office/office"
import {ElForm} from "element-ui/types/form"

export default Vue.extend({
  data() {
    return {
      rules: {
        homeDepot: [{
          required: true, message: this.$t("user_administration.other.home_depot_validation"),
          trigger: "change"
        }, {
          max: 4,
          message: `${this.$t("user_administration.max")} 4 ${this.$t("user_administration.chars")}`,
          trigger: "change"
        }],
        businessUnit: [{
          required: true, message: this.$t("user_administration.other.business_unit_validation"),
          trigger: "change"
        }, {
          max: 50,
          message: `${this.$t("user_administration.max")} 50 ${this.$t("user_administration.chars")}`,
          trigger: "change"
        }]
      }
    }
  },
  props: {
    office: {
      type: Object as () => Office,
      required: true
    },
    formValid: {
      type: Boolean,
      required: true
    },
    pageFormats: {
      required: true,
      default: () => []
    },
    charsets: {
      required: true,
      default: () => []
    }
  },
  methods: {
    validateForm() {
      const form = this.$refs["form"] as ElForm
      let validationResult = false
      if (!!form) {
        form.validate(valid => {
          validationResult = valid
        })
      }
      this.$emit("update:formValid", validationResult)
    }
  },
  watch: {
    office: {
      deep: true,
      handler() {
        this.validateForm()
      }
    }
  },
  mounted() {
    this.validateForm()
  }
})
